var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsArray, IsInt, IsOptional, IsString, MaxLength, ValidateNested } from 'class-validator';
import { CreateCustomFormElementDto } from './create-custom-form-element.dto.js';
/**
 * A section in a nested create payload. Elements are section-scoped; their
 * position in `createCustomFormElements` defines their (section-scoped) index.
 */
export class CreateCustomFormSectionDto {
    title;
    index;
    createCustomFormElements;
}
__decorate([
    IsString(),
    MaxLength(255),
    __metadata("design:type", String)
], CreateCustomFormSectionDto.prototype, "title", void 0);
__decorate([
    IsOptional(),
    IsInt(),
    __metadata("design:type", Number)
], CreateCustomFormSectionDto.prototype, "index", void 0);
__decorate([
    IsArray(),
    IsOptional(),
    ValidateNested({ each: true }),
    Type(() => CreateCustomFormElementDto),
    __metadata("design:type", Array)
], CreateCustomFormSectionDto.prototype, "createCustomFormElements", void 0);
//# sourceMappingURL=create-custom-form-section.dto.js.map